export default [{ text: 'Clinic', value: 'Clinic' }, { text: 'Hospital', value: 'Hospital' }];



// WEBPACK FOOTER //
// ./src/data/practiceTypes.js